import { redirect } from 'react-router-dom';

const protectUser = async () => {
    const access_token = localStorage.getItem('access_token');
    if (!access_token) return redirect('/login');
    return null;
};

export default protectUser;
